export default __webpack_public_path__ + "static/media/il.6701e0f0.svg";